import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  FormInputComponent,
  InputComponentConfig,
  SharedModule,
} from '@vendure/admin-ui/core';

/**
 * Vendure's `currency-form-input`, fixed to euro. The built-in input always
 * shows the channel currency, which is GBP on IOI.
 */
@Component({
  selector: 'ft-eur-currency-form-input',
  imports: [SharedModule],
  template: `<vdr-currency-input
    [formControl]="formControl"
    [readonly]="readonly"
    currencyCode="EUR"
  ></vdr-currency-input>`,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EurCurrencyFormInputComponent implements FormInputComponent {
  static readonly id = 'eur-currency-form-input';
  @Input() readonly: boolean;
  formControl: UntypedFormControl;
  config: InputComponentConfig;
}
